import React, { useState, useEffect } from 'react';
import '../../styles/richTextEditor.css'

/**
 * Component for rich text editor. It uses React lifecycle method for setting & updating the editor content
 * It also emits change events with each update. It takes two props , one is the content to update 
 * and other is onChange function to call on each update
 */
export const RichTextEditor = (props) => {

    // Default extensions for text editor
    const defaultExtensions = [
        {
          icon: 'omni:editor:undo',
          method: 'undo',
          tooltip: 'Undo',
          order: 0,
        },
        {
          icon: 'omni:editor:redo',
          method: 'redo',
          tooltip: 'Redo',
          order: 1,
        },
        {
          icon: 'omni:editor:bold',
          method: 'bold',
          tooltip: 'Bold',
          order: 2,
        },
        {
          icon: 'omni:editor:italics',
          method: 'italic',
          tooltip: 'Italize',
          order: 3,
        },
        {
          icon: 'omni:editor:underline',
          method: 'underline',
          tooltip: 'Underline',
          order: 4,
        },
        {
          icon: 'omni:editor:bulletList',
          method: 'insertUnorderedList',
          tooltip: 'Bullet List',
          order: 5,
        },
        {
          icon: 'omni:editor:numberList',
          method: 'insertOrderedList',
          tooltip: 'Number List',
          order: 6,
        }
    ]

    const [extensions, setExtensions] = useState(defaultExtensions);
    const editorRef = React.useRef('');

    // Using useEffect hooks for updating editor content on first component load
    useEffect(()=>{
        editorRef.current.innerHTML = props.content;
    },[])

    /**
    * This function will be called on each extension button click to update the editor with specific styles/format.
    */
    const handleMenuButtonClick = (button) => {
        // to make clicked extension button active
        if(button.method === 'bold' || button.method === 'italic' || button.method === 'underline'){
            setExtensions((prevState)=>{
                prevState[button.order]['active'] = !prevState[button.order].active;
                
                if(button.method === 'insertUnorderedList')
                    prevState[6]['active'] = false;
                else if(button.method === 'insertOrderedList')
                    prevState[5]['active'] = false;

                return [...prevState];
            })
        }
        document.getElementById("editor").focus();
        document.execCommand(button.method, false, null);
    }
    
    /**
    * This function will be called on each update which will emits events that contains latest content.
    */
    const emitChange = () => {
        let html = editorRef.current.innerHTML;
        if (props.onChange) {
            props.onChange({
                target: {
                    value: html
                }
            });
        }
    }
    
    /**
    * This function will be called on each render to create menu bar containing all extensions.
    */
    const menubarTemplate = () => {
        return (
            <div className="menu-container">
                {
                    extensions.map((extension)=>{
                        return(
                            <omni-tooltip key={extension.order}>
                                <button
                                className= {`button ${extension.active ? 'is-active' : ''}`}
                                slot="invoker"
                                onClick={handleMenuButtonClick.bind(this, extension)}
                                >
                                    <omni-icon icon-id={extension.icon} className="is-size-2"></omni-icon>
                                </button>
                                <div slot="content">{extension.tooltip}</div>
                            </omni-tooltip>
                        )
                    })
                }
            </div>
        )
    }

    return (
        <omni-style>
            <div className='rich-text-component'>
                {menubarTemplate()}
                <div 
                    id="editor" 
                    ref={editorRef}
                    placeholder= {props.placeholder}
                    contentEditable="true"
                    onInput={emitChange}
                    onBlur={emitChange}
                ></div>
            </div>
        </omni-style>
    )
}
